export default {"src":"/_next/static/media/radio.0f496b44.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};